import  Navbar  from './NavbarES';
import  Footer  from './FooterES';
import { useState } from 'react';
import { InfinitySpin } from 'react-loader-spinner'
import axios from 'axios';
import Wpp from '../Wpp';


function Contact(){

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [emailSent, setEmailSent] = useState(false);

    // API proxied through Nginx - uses same domain and SSL cert
    const api_url = window.location.origin;

    function SendEmail() {

        

        if (loading == false && emailSent == false) {
            return (
                <button class="btn btn-primary mt-4" type="submit" onClick={e => send()} disabled={!name || !email || !message}>Enviar</button>
            )
        } else if(emailSent == true && loading == false){
            return(
                <div style={{textAlign:'center', color:'green'}}>Hemos recibido su consulta. Un experto se pondra en contacto a la brevedad. Gracias!</div>
            )
        }
         else if(loading == true) {
            return (
                <InfinitySpin color="#4fa94d" />
            )
        }

    }

    const send = () => {
        setLoading(true);

        axios({
            method:'POST',
            url:api_url+'/api/send_contact_email',
            data:{
                name:name,
                email:email,
                message:message
            }
        }).then(res => {
            console.log("Email status "+res.status);
            if(res.status === 200){
                setEmailSent(true);
                setLoading(false);
                setMessage('');
            }else{
                setLoading(false);
                alert("There was a problem sending your email. Please try again. Thank you.");
            }
            
        }).catch(error => {
            console.log("Error sending contact email:", error);
            setLoading(false);
            alert("Hubo un problema al enviar tu mensaje. Por favor intenta de nuevo. Gracias.");
        });

    }

    return(
        <>
        <Navbar />
        <div id="layoutDefault">
            <div id="layoutDefault_content">
                <main>
                    <header class="page-header-ui page-header-ui-dark bg-gradient-primary-to-secondary">
                        <div class="page-header-ui-content pt-10">
                            <div class="container px-5 text-center">
                                <div class="row gx-5 justify-content-center">
                                    <div class="col-lg-8">
                                        <h1 class="page-header-ui-title mb-3">Contactanos</h1>
                                        <p class="page-header-ui-text">¿Preguntas? ¡Estamos acá para ayudar!</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="svg-border-rounded text-light">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 144.54 17.34" preserveAspectRatio="none" fill="currentColor"><path d="M144.54,17.34H0V0H144.54ZM0,0S32.36,17.34,72.27,17.34,144.54,0,144.54,0"></path></svg>
                        </div>
                    </header>
                    <section class="bg-light py-10">
                        <div class="container px-5">
                            
                            <div class="row gx-5 justify-content-center">
                                <div class="col-lg-8 text-center">
                                    <h2>¿No encontras la respuesta que estas buscando?</h2>
                                    <p class="lead mb-5">Contactanos y te responderemos en cuanto antes.</p>
                                </div>
                            </div>
                            <div class="row gx-5 align-items-center mb-10">
                                <div class="col-lg-4 text-center mb-5 mb-lg-0">
                                    <div class="section-preheading">Mandanos un mensaje</div>
                                    <a href="https://wa.me/+541136555405">Whatsapp</a>
                                </div>
                                <div class="col-lg-4 text-center mb-5 mb-lg-0">
                                    <div class="section-preheading">Llamanos</div>
                                    <a href="tel:+54-11-3655-5405">+54 11 3655-5405</a>
                                </div>
                                <div class="col-lg-4 text-center">
                                    <div class="section-preheading">Correo electronico</div>
                                    <a href="mailto:info@primetaxonline.com">info@primetaxonline.com</a>
                                </div>
                            </div>
                            
                                <div class="row gx-5 mb-4">
                                    <div class="col-md-6">
                                        <label class="text-dark mb-2" for="inputName">Nombre</label>
                                        <input class="form-control py-4" onChange={e => setName(e.target.value)} id="inputName" type="text" placeholder="Nombre" />
                                    </div>
                                    <div class="col-md-6">
                                        <label class="text-dark mb-2" for="inputEmail">Correo electronico</label>
                                        <input class="form-control py-4" id="inputEmail" onChange={e => setEmail(e.target.value)} type="email" placeholder="nombre@example.com" />
                                    </div>
                                </div>
                                <div class="mb-4">
                                    <label class="text-dark mb-2" for="inputMessage">Mensaje</label>
                                    <textarea class="form-control py-3" id="inputMessage" type="text" value={message} onChange={e => setMessage(e.target.value)} placeholder="Escriba su mensaje..." rows="4"></textarea>
                                </div>
                                <div class="text-center"><SendEmail /></div>
                            
                        </div>
                        <div class="svg-border-rounded text-dark">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 144.54 17.34" preserveAspectRatio="none" fill="currentColor"><path d="M144.54,17.34H0V0H144.54ZM0,0S32.36,17.34,72.27,17.34,144.54,0,144.54,0"></path></svg>
                        </div>
                    </section>
                </main>
            </div>
            <Wpp />
            <Footer />
        </div>
        </>
    )
}

export default Contact;